























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { AgendamentoCirurgia } from '@/types/_'

@Component
export default class ModalBackofficeGerenciarCirurgiaConjunta extends Vue {
  @Prop() visible: boolean
  @Prop() agendamento: AgendamentoCirurgia

  get show() {
    return this.visible
  }

  set show(val: boolean) {
    if (!val) {
      this.close()
    }
  }

  @Emit('close')
  close() {}

  @Emit('atualizado')
  atualizado() {}
}
